import React, { useEffect, useState } from "react";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { DEFAULT_FRANCHISE_ID } from "../config/FranchisesConfig";
import { api } from "common";

const FranchiseSelector = ({
  setSelectedFranchiseId, selectedFranchiseId,
  onChange,
}) => {
  const dispatch = useDispatch();
  const [franchises, setFranchises] = useState([]);
  const { fetchFranchises } = api;
  const franchiseData = useSelector((state) => state.franchisedata);
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(fetchFranchises());
    setSelectedFranchiseId(DEFAULT_FRANCHISE_ID);
  }, [dispatch, fetchFranchises, auth.profile.franchise_id]);

  useEffect(() => {
    if (franchiseData && franchiseData.franchises) {
      const defaultFranchise = {
        id: DEFAULT_FRANCHISE_ID,
        name: "Default Franchise",
      };

      const franchiseList = [defaultFranchise, ...franchiseData.franchises];
      setFranchises(franchiseList);
    }
  }, [franchiseData]);

  useEffect(() => {
    if (franchiseData && franchiseData.franchises) {
      const allFranchisesOption = {
        id: "all",
        name: "All Franchises",
      };

      const franchiseList = [allFranchisesOption, ...franchiseData.franchises];
      setFranchises(franchiseList);
    }
  }, [franchiseData]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
        marginBottom: 20,
      }}
    >
      <FormControl
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: 150,
          fontSize: "0.8rem",
          zIndex: 1000,
          marginTop: 20,
        }}
      >
        <InputLabel id="franchise-select-label">Franchise</InputLabel>
        <Select
          labelId="franchise-select-label"
          value={selectedFranchiseId}
          onChange={onChange}
          label="Franchise"
        >
          {franchises.map((franchise) => (
            <MenuItem key={franchise.id} value={franchise.id}>
              {franchise.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default FranchiseSelector;
